import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { UsrCred } from "./../../models/usrcred";
import { VproService } from "./../../service/vpro/vpro.service";
import { SocketsConnectionService } from "./../../service/websockets/connection.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent {
  user = new UsrCred();
  dataValue: boolean;
  dataValue2: number;
  dataValue3: string;
  dataValue4: number;

  awstok: string;
  Ecode: number;
  innerHtml: string = "";
  constructor(private loginService: VproService, private router: Router, private utils: Utils, private spinner: NgxSpinnerService,
    private socketsConnectionService: SocketsConnectionService) { }

  // ngOnInit() {
  // }

  /**function authUser for login  */
  authUser() {
    localStorage.setItem("LogUsr", this.user.email_id); // Capturing Loggedin User
    try {
      this.spinner.show();
      this.loginService.authUser(this.user).subscribe(
        (data) => {
          this.spinner.hide();
          this.dataValue = data["auth"];
          this.dataValue2 = data["roles"];
          this.dataValue3 = data["orgcode"];
          this.dataValue4 = data["uid"];

          localStorage.setItem("orgcode", this.dataValue3);
          localStorage.setItem("LogUsrTyp", JSON.stringify(this.dataValue2));
          localStorage.setItem("uid", JSON.stringify(this.dataValue4));

          this.socketsConnectionService.subscribeToSockets();
          this.awstok = data["stok"];

          // Check for activation status
          if (data && this.dataValue == false) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 5000,
            });

            Toast.fire({
              type: "warning",
              title: "Access Denied",
              text: "Check your mail for activation link and get it verified",
            });

            this.router.navigate(["/login"]);
          }

          if (this.dataValue2 === 9) {
            //  this.Ecode = 0;
            this.innerHtml =
              "    <b>Sorry ..! Please check your Credentials</b>";
          }

          if (this.dataValue2 === 8) {
            //  this.Ecode = 0;
            this.innerHtml =
              "<b>We do not have this Email-id registered with us</b>";
          }


          if (data && this.utils.checkRoleType(Utils.USER_TYPE.admin, this.dataValue2)) {
            // tslint:disable-next-line:max-line-length
            // localStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWJqZWN0IjoiNWMxM2M1YmE5YWRmNWYzZWVjZGE3YTRhIiwiaWF0IjoxNTQ0ODY4NDM0fQ.9jtYCfprro1VxsLOZKqIMDDXHokWJXHHP94JEPHK1Yc');

            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Admin",
            });
            this.router.navigate(["/admindashboard"]);
          }

          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.superadmin, this.dataValue2)) {
            // tslint:disable-next-line:max-line-length
            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Superadmin",
            });

            this.router.navigate(["/superadmin/physicians"]);
          }

          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.physician, this.dataValue2)) {
            // tslint:disable-next-line:max-line-length
            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Physician",
            });

            this.router.navigate(["/dashboard"]);
          }
          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.front_desk, this.dataValue2)) {
            // tslint:disable-next-line:max-line-length
            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Front-Desk Person",
            });

            this.router.navigate(["/dashboard"]);
          }

        },
        (error) => {
          this.spinner.hide();
          let message = 'Something went wrong !'
          if (error.error && error.error.internalError) {
            message = JSON.parse(error.error.internalError).message;
          }
          this.innerHtml = `<div class="text-danger">${message}</div>`;
        }
      );
    } catch (excep) {
      this.spinner.hide();
    }
  }
}
